module.exports = __webpack_public_path__ + "img/dash-card-withdraw.e4127813.svg";